<template>
    <button @click="goToApp()" class="app-router-link">
        <slot></slot>
    </button>
</template>

<script>
import ApplicationService from "@/services/ApplicationService";

export default {
    name: "app-router-link",
    props: {
        url: {
            required: true,
            type: String
        },
        appId: {
            required: true
        },
        appName: {
            required: true,
            type: String
        }
    },
    methods: {
        goToApp() {
            ApplicationService.goToApplication(this.appId);
            // window.open(this.url, "_blank");
            window.location.href = this.url;
        }
    }
}
</script>
